import { useSelector } from 'react-redux';
import { DialogTitle } from '@mui/material';

import { selectEventDialogData } from 'main/store/schedule/selectors';

export const Title = () => {
    const dialogData = useSelector(selectEventDialogData);

    return (
        <DialogTitle sx={{ textAlign: 'center' }}>
            {dialogData!.date}
        </DialogTitle>
    )
}
